import { ConsentProvider } from '@consent-ui';
import {
  grantConsent,
  revokeConsent,
  getManageableConsents,
  getConsentHistory,
} from '@/api/stnApi';

/**
 * Supplies StartupNexus's wiring to the shared consent UI.
 *
 * The subject here is a FOUNDER, not a student — but nothing below says so, and
 * that's deliberate: the backend resolves the role from the token and returns
 * the catalogue rows that apply to founders. A client asserting its own user
 * type would be a claim it isn't entitled to make.
 *
 * No `completeOAuthSignup`: StartupNexus has no OAuth signup, so that half is
 * simply absent. The shared hooks fail loudly if a flow needing a missing
 * function is ever reached, rather than silently doing nothing.
 */
export default function AppConsentProvider({ children }) {
  return (
    <ConsentProvider
      api={{
        grantConsent,
        revokeConsent,
        getManageable: getManageableConsents,
        getHistory: getConsentHistory,
      }}
      // StartupNexus's shadcn tokens — violet primary (263 70% 50%), and the
      // same token names in light and dark, so this follows the app's theme
      // switch without a second palette here.
      theme={{
        surface:      'bg-card',
        border:       'border-border',
        borderHover:  'hover:border-primary/40',
        text:         'text-foreground',
        textMuted:    'text-muted-foreground',
        textFaint:    'text-muted-foreground',
        accent:       'text-primary',
        accentBg:     'bg-primary/10',
        accentButton: 'bg-primary hover:opacity-90',
        checkbox:     'accent-primary',
        ghostHover:   'hover:bg-muted',
        errorBox:     'bg-destructive/10 text-destructive',
        privacyUrl:   'https://nexusaiweb.com/privacy',
      }}
    >
      {children}
    </ConsentProvider>
  );
}
